import React from 'react'
import {KTIcon} from "../../../../_metronic/helpers"
import {useQuery} from "react-query";
import {getAllStats} from "../../../services/statsSvc";
import {separateFormatter} from "../../../utils/separateFormatter";

export const StatsSection = () => {
  const {data: allStats} = useQuery("getAllStats", getAllStats)

  return (
      <div className="row g-6 g-xl-9">
        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-1.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"notepad-bookmark"} className={"fs-4x text-success"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Yangiliklar</h3>
              <span className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.news_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-2.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"people"} className={"fs-4x text-success"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Foydalanuvchilar</h3>
              <span className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.user_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-3.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"information-2"} className={"fs-4x text-danger"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Xavflilar soni</h3>
              <span className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.victim_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-4.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"to-right"} className={"fs-4x text-warning"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Darslar</h3>
              <span
                  className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.lesson_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>


        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-1.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"message-question"} className={"fs-4x text-info"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Savollar</h3>
              <span
                  className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.question_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-2.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"satellite"} className={"fs-4x text-danger"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">SOS murojaatlar</h3>
              <span className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.help_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-3.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"question-2"} className={"fs-4x text-success"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Testlar</h3>
              <span
                  className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.test_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
          <div className="card card-flush h-md-100" style={{
            backgroundPosition: "right top",
            backgroundSize: "40%",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url("/media/svg/shapes/abstract-4.svg")',
          }}>
            <div className="card-body">
              <KTIcon iconName={"user-tick"} className={"fs-4x text-secondary"} iconType={"duotone"}/>
              <h3 className="text-gray-800 mt-2">Talabalar</h3>
              <span
                  className="fs-3x text-dark fw-bold">{separateFormatter(allStats?.student_count, " ", "") || 0}</span>
            </div>
          </div>
        </div>
      </div>
  )
}
